import { type SiteState, type SyncState, siteState, snapshotAgeSeconds } from "../shared/project-state";

export interface UserSession {
  authenticated: boolean;
  email?: string;
  name?: string;
  picture?: string;
  admin?: boolean;
}

export interface StatusPayload {
  state: SiteState;
  syncState: SyncState;
  fetchedAt: string;
  sourceGeneratedAt: string;
  sourceAgeSeconds: number;
}

export async function fetchStatus(signal?: AbortSignal): Promise<StatusPayload> {
  try {
    const response = await fetch("/api/status", {
      credentials: "include",
      signal,
      headers: { accept: "application/json" },
    });
    if (!response.ok) throw new Error(`status ${response.status}`);
    const payload = (await response.json()) as StatusPayload;
    return payload;
  } catch {
    return {
      state: { ...siteState, sourceMode: "fallback" },
      syncState: "fallback",
      fetchedAt: new Date().toISOString(),
      sourceGeneratedAt: siteState.generatedAt,
      sourceAgeSeconds: snapshotAgeSeconds(siteState),
    };
  }
}

export async function fetchMe(signal?: AbortSignal): Promise<UserSession> {
  try {
    const response = await fetch("/api/auth/me", {
      credentials: "include",
      signal,
      headers: { accept: "application/json" },
    });
    if (!response.ok) return { authenticated: false };
    return (await response.json()) as UserSession;
  } catch {
    return { authenticated: false };
  }
}

export async function logout() {
  await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
}
